<template>
  <div class="m-tabs position-relative">
    <ul class="m-tabs__items list-unstyled m-0 d-flex">
      <li v-for="tab in tabs" :key="tab.key" class="m-tabs__item d-flex justify-content-center flex-fill">
        <button v-if="$isNotNullOrUndefined(tab.name)" class="m-tabs__button py-2" :class="{'-active': tab.isActive }" @click="setActiveTab(tab)">
          {{ tab.name }}
        </button>
      </li>
    </ul>
    <div class="m-tabs__content text-small py-5">
      <slot />
    </div>
  </div>
</template>
    
<script>

export default {
  name: 'Tabs',	
  props: {
  },
  data () {
    return {
      tabs: [] 
    };
  },
  computed: {
    
  },
  mounted () {
    this.tabs = this.$children;
  },
  methods: {
    setActiveTab (selectedTab) {
      this.tabs.forEach(tab => {
        tab.isActive = (tab.name == selectedTab.name);
      });
    }
  }
}
</script>
